'use client';

import { Fragment } from 'react';

import { MobileAppFrame } from '@/shared-mobile-app';
import { isMobileAppDebugMode } from '@/shared-survey';

import ProjectUsabilityImageChoiceStage from './project-usability-image-choice-stage';
import ProjectUsabilityMobileAppDebug from './project-usability-mobile-app-debug';
import { useUsabilityResponseContext } from './project-usability-response-context';
import ProjectUsabilityResponseIframe from './project-usability-response-iframe';
import ProjectUsabilityResponseSubmitted from './project-usability-response-submitted';

export default function ProjectUsabilityResponseMainFrame() {
  const { project, session, stage } = useUsabilityResponseContext();

  const {
    showSubmitted,
    handleImageChoiceSubmit,
    isSubmitting,
    effectiveIsConversationOver,
    mobileAppEmbedUrl,
    isConversationOver,
    searchParams,
    contentUrl,
  } = session;
  const {
    isImageChoiceActive,
    lastAssistantMessage,
    imageChoiceSelection,
    setImageChoiceSelection,
    isMobileAppPreloading,
  } = stage;

  if (showSubmitted) {
    return (
      <div className='flex-1 rounded-2xl bg-gray-100 transition-all duration-300 ease-in-out'>
        <ProjectUsabilityResponseSubmitted />
      </div>
    );
  }
  const imageChoiceOverlay =
    isImageChoiceActive && lastAssistantMessage ? (
      <ProjectUsabilityImageChoiceStage
        key={lastAssistantMessage.id}
        message={lastAssistantMessage}
        onSubmit={handleImageChoiceSubmit}
        isSubmitting={isSubmitting}
        isConversationOver={effectiveIsConversationOver}
        showSendButton={false}
        value={imageChoiceSelection.value}
        onChange={(next) =>
          setImageChoiceSelection({
            messageId: lastAssistantMessage.id,
            value: next,
          })
        }
        className='absolute inset-0 z-20 rounded-4xl'
      />
    ) : null;
  const mobileAppIframe = mobileAppEmbedUrl ? (
    <MobileAppFrame
      embedUrl={mobileAppEmbedUrl}
      language={project.language}
      containerClassName='flex-1 transition-all duration-300 ease-in-out z-10'
      isConversationOver={isConversationOver}
      debugEnabled={isMobileAppDebugMode(searchParams)}
      isHidden={isMobileAppPreloading}
      renderDebugPanel={(debugPanelProps) => (
        <ProjectUsabilityMobileAppDebug {...debugPanelProps} />
      )}
    >
      {!isMobileAppPreloading ? imageChoiceOverlay : null}
    </MobileAppFrame>
  ) : null;

  if (mobileAppEmbedUrl && !isMobileAppPreloading) {
    return mobileAppIframe;
  }
  return (
    <Fragment key='content-iframe-stack'>
      {mobileAppIframe}
      <ProjectUsabilityResponseIframe
        contentUrl={contentUrl}
        containerClassName='flex-1 transition-all duration-300 ease-in-out z-10'
        isConversationOver={isConversationOver}
      >
        {imageChoiceOverlay}
      </ProjectUsabilityResponseIframe>
    </Fragment>
  );
}
